export const appInfo = {
  version: __APP_VERSION__,
  buildNumber: __BUILD_NUMBER__,
} as const

export function formatAppVersionLabel(): string {
  const base = `v${appInfo.version}`
  if (appInfo.buildNumber) return `${base} · #${appInfo.buildNumber}`
  return import.meta.env.DEV ? `${base} · dev` : base
}
